import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div className="border-b border-slate-200 py-8">
    <h2 className="text-base font-semibold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
      {children}
    </div>
  </div>
);

export default function Support() {
  return (
    <div className="fixed inset-0 z-40 overflow-y-auto bg-white text-left">
      <div className="mx-auto max-w-2xl px-4 pb-10 pt-6 md:px-8 md:pb-14">
        <Link
          to="/"
          className="inline-flex items-center text-sm text-slate-500 hover:text-slate-900"
        >
          &larr; Back to Home
        </Link>
        <h1 className="mt-5 text-2xl font-semibold text-slate-900 md:text-3xl">
          Support
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          We're here to help you get the most out of Kakeibo.
        </p>
      </div>

      <div className="mx-auto max-w-2xl px-4 md:px-8">
        <Section title="Contact Us">
          <p>
            If you have any questions, feedback, or need help with the app,
            please reach out to us at:
          </p>
          <p>
            <a
              href="mailto:support@ymym.io"
              className="text-slate-900 underline hover:text-slate-700"
            >
              support@ymym.io
            </a>
          </p>
        </Section>

        <Section title="Frequently Asked Questions">
          <p className="font-semibold text-slate-800">
            How do I create a budget?
          </p>
          <p>
            Go to the Budget tab, select a category, and set your monthly
            budget amount. You can create budgets for income, fixed expenses,
            regular expenses, and savings.
          </p>

          <p className="font-semibold text-slate-800">
            Can I create custom categories?
          </p>
          <p>
            Yes! Go to Settings → Categories to add, edit, or remove
            categories that match your spending habits.
          </p>

          <p className="font-semibold text-slate-800">
            How do I track an expense?
          </p>
          <p>
            Tap the + button on the Expenses tab to add a new expense. Enter
            the title, amount, and select a category.
          </p>

          <p className="font-semibold text-slate-800">Is my data secure?</p>
          <p>
            Your data is stored securely and transmitted over encrypted
            connections. We take your privacy seriously — see our{" "}
            <Link
              to="/privacy"
              className="text-slate-900 underline hover:text-slate-700"
            >
              Privacy Policy
            </Link>{" "}
            for details.
          </p>

          <p className="font-semibold text-slate-800">
            How do I view reports?
          </p>
          <p>
            Go to the Reports tab to see spending breakdowns by category,
            overview charts, and budget comparisons.
          </p>

          <p className="font-semibold text-slate-800">
            How do I delete my account?
          </p>
          <p>
            To request account deletion and removal of all associated data,
            please contact us at{" "}
            <a
              href="mailto:support@ymym.io"
              className="text-slate-900 underline hover:text-slate-700"
            >
              support@ymym.io
            </a>
            .
          </p>
        </Section>

        <Section title="What is Kakeibo?">
          <p>
            Kakeibo is a Japanese budgeting method created in 1904. It
            encourages mindful spending by organizing finances into categories:
            income, fixed expenses, regular expenses, and savings. By
            reflecting on each purchase, you naturally spend less and save
            more.
          </p>
        </Section>

        <div className="py-8">
          <h2 className="text-base font-semibold text-slate-900">
            App Version
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            Kakeibo is available on{" "}
            <a
              href="https://ymym.io"
              className="text-slate-900 underline hover:text-slate-700"
            >
              Web
            </a>{" "}
            and iOS.
          </p>
        </div>
      </div>

      <footer className="mx-auto max-w-2xl border-t border-slate-200 px-4 py-6 text-xs text-slate-400 md:px-8">
        &copy; {new Date().getFullYear()} Kakeibo. All rights reserved.
      </footer>
    </div>
  );
}
